interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  children: React.ReactNode
}

export const Button = ({ children, className = "", ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      className={`relative cursor-pointer overflow-hidden rounded-full border border-transparent bg-violet-600 px-6 py-3 outline-none ${className}`}>
      {children}
    </button>
  )
}
